import react from 'react';

/**
 * @param {string} props.id - アイテムのuuid
 * @param {string} props.label - アイテムの名前
 * @param {boolean} props.isActive - アイテムがアクティブかどうか
 */
const Checkbox = (props) => {
  // let id;
  // if(props.id == '入社時期') {
  //   id = 2000;
  // } else if(props.id == '採用区分'){
  //   id = 3000;
  // } else {
  //   id = props.id;
  // }
  return (
    <div className="p-check-list__item c-check-box -size_M">
      <input
        className="c-check-box__input"
        type="checkbox"
        name={`checkBox-${props.id}`}
        id={`checkBox-${props.id}`}
        checked={props.isActive}
        data-id={props.id}
        onChange={(item) => {
          props.onClick(item.currentTarget.dataset.id);
        }}
        aria-label={props.label}
      />
      <label className="c-check-box__label" for={`checkBox-${props.id}`} key={`key_${props.id}`}>{props.label}<span></span></label>
    </div>
  );
}

export default Checkbox;